<template>
  <div class="update-alert">
    <img alt="Update alert"
         src="/static/img/update_alert/industries/Portal_Better-way-to-browse.webp"
         srcset="/static/img/update_alert/industries/Portal_Better-way-to-browse@2x.webp 1.5x, /static/img/update_alert/industries/Portal_Better-way-to-browse@2x.webp 2x, /static/img/update_alert/industries/Portal_Better-way-to-browse@3x.webp 3x"/>
    <div class="update-alert__content">
      <div class="update-alert__title">We’ve refined our industry categories!</div>
      <div class="margin-bottom-10">
        <router-link :to="{ name: 'BusinessProfile' }">
          <img src="/static/img/update_alert/industries/choose_cat.svg"   />
        </router-link>
      </div>
      that best describes what you do to make your business more discoverable and accurately ranked.
      <hr/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheUpdateAlert'
}
</script>

<style lang="scss" scoped>
.update-alert {
  text-align: center;

  * {
    font-family: Roboto;
  }

  &__content {
    font-size: 12px;
    color: #58595b;
    max-width: 322px;
    margin: 17px auto 0;
    padding: 0 25px;

    img {
      width: 160px;
    }

    hr {
      background-color: #eaeaea;
      margin-top: 21px;
      margin-bottom: 13px;

      @media screen and (max-width: 767px) {
        visibility: hidden;
      }
    }
  }

  &__title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/TheUpdateAlert.vue